import React from 'react';
import { useHistory } from 'react-router-dom';
import css from './SectionHero.css';
import { Button } from '../../../../components';
import { createResourceLocatorString } from '../../../../util/routes';
import routeConfiguration from '../../../../routeConfiguration';
import { parse } from '../../../../util/urlHelpers';
import config from '../../../../config';

const { userTypeHorseowner } = config;

export default () => {
    const history = useHistory();
    const { role } = parse(history.location.search);

    return (
        <>
            <section className={css.root}>
                <header>
                    <h1 className={css.subHeading}>Preisgestaltung</h1>
                    <p className={css.superHeading}>
                        Ein erfolgsbasiertes Preismodell ganz ohne versteckte Kosten.
                    </p>
                    <p className={css.description}>
                        {`Wir glauben an die Stärke unseres Matchings und haben deshalb ein faires Modell entwickelt, das auf Erfolg basiert und dir den grössten Mehrwert bietet.`}
                    </p>
                </header>

                <footer className={css.footer}>
                    <Button
                        className={css.subLinkPrimary}
                        onClick={() =>
                            history.push(
                                createResourceLocatorString(
                                    role === userTypeHorseowner
                                        ? 'SignupRider'
                                        : 'SignupHorseowner',
                                    routeConfiguration()
                                )
                            )
                        }
                    >
                        Kostenlos registrieren
                    </Button>
                </footer>
            </section>
            <div className={css.root}>
                <h2 className={css.subHeading}>Credits hinzufügen</h2>
                <p className={css.heading}>
                    Was sind Credits und welche Möglichkeiten habe ich, sie zu erhalten?
                </p>
                <p className={css.description}>
                    Credits sind deine Währung auf HorseDeal. Mit ihnen schaltest Du hilfreiche
                    Funktionen frei, die dich zu deinem Match führen. Du erhältst Credits kostenlos
                    über Rewards oder im Vorteilspaket zum Fixpreis - unbegrenzt gültig und ohne
                    Verfallsdatum.
                </p>
            </div>
        </>
    );
};
